import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

function TableHead({ children }) {
    return (
        <div className="table-head">
            {
                children
            }
        </div>
    );
}

TableHead.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export default TableHead;
